import { render, staticRenderFns } from "./HTMLBlock.vue?vue&type=template&id=3f80fc29&"
import script from "./HTMLBlock.vue?vue&type=script&lang=js&"
export * from "./HTMLBlock.vue?vue&type=script&lang=js&"
import style0 from "./HTMLBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports